module.exports = __webpack_public_path__ + "media/25.f8fb91a8.mp3";